/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  connect
} from 'react-redux';
import { Field, FieldWrapper } from '@progress/kendo-react-form';
import { CustomDropDownInputUnwrapped } from 'components/shared/form/custom_dropdown_input';
import { CustomInput } from 'components/shared/form/custom_input';
import { CustomKendoDatePicker } from 'components/shared/form/custom_date_input';
import content from 'utility/token_helper';
import { Error } from '@progress/kendo-react-labels';
import { CustomTextarea } from 'components/shared/form/custom_textarea';
import moment from 'moment';

// eslint-disable-next-line max-len
function RegistrationCheck(props) {
  const {
    errors
  } = props.formRenderProps;

  const userActionForm = (
    <div>
      <Field
        id="profession"
        name="profession"
        dropDownValues={props.professions}
        label={content('physician', 'mqa-check-profession', props.categoryClientContent)}
        component={CustomDropDownInputUnwrapped}
        aria-label="Select your license profession"
      />
      <Error>{errors?.requiredProfession}</Error>
      <Field
        id="licenseNumber"
        name="licenseNumber"
        label={content('physician', 'mqa-check-license-number', props.categoryClientContent)}
        component={CustomInput}
        maxLength={32}
        aria-label="License Number"
      />
      <Error>{errors?.requiredLicenseNumber}</Error>
      <Error>{errors?.formatLicenseNumber}</Error>
      <Field
        id="firstName"
        name="firstName"
        label={content('physician', 'mqa-check-first-name', props.categoryClientContent)}
        component={CustomInput}
        aria-label="First Name"
      />
      <Error>{errors?.requiredFirstName}</Error>
      <Error>{errors?.formatFirstName}</Error>
      <Field
        id="lastName"
        name="lastName"
        label={content('physician', 'mqa-check-last-name', props.categoryClientContent)}
        component={CustomInput}
        aria-label="Last Name"
      />
      <Error>{errors?.requiredLastName}</Error>
      <Error>{errors?.formatLastName}</Error>
      <FieldWrapper>
        <Field
          id="dob"
          name="dob"
          label={content('physician', 'mqa-check-dob', props.categoryClientContent)}
          component={CustomKendoDatePicker}
          max={moment().format('YYYY-MM-DD')}
          aria-label="DOB"
        />
      </FieldWrapper>
      <Error>{errors?.requiredDOB}</Error>
      <Error>{errors?.formatDOB}</Error>
      <Field
        id="lastFourSSN"
        name="lastFourSSN"
        label={content('physician', 'mqa-check-last-four-ssn', props.categoryClientContent)}
        component={CustomInput}
        maxLength={4}
        aria-label="Last Four SSN"
      />
      <Error>{errors?.requiredLastFourSSN}</Error>
      <Error>{errors?.formatLastFourSSN}</Error>
      {!props.newPhysicianRegistration && (
        <>
          <Field
            id="justification"
            name="justification"
            label={content('physician', 'mqa-check-justification', props.categoryClientContent)}
            component={CustomTextarea}
            max={255}
            aria-label="justification"
          />
          <Error>{errors?.requiredJustification}</Error>
          <Error>{errors?.formatJustification}</Error>
        </>
      )}
    </div>
  );

  return (
    <div>
      {userActionForm}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    categoryClientContent: state?.content?.categoryClientContent ?? state.content.anonymousCategoryClientContent,
  };
}
export default connect(mapStateToProps)(RegistrationCheck);
